import { motion } from "framer-motion";
import { B } from "../data/pillars";

export default function Gauge({ score, max = 5, size = 140, color }) {
  const pct  = Math.min(score / max, 1);
  const r    = (size / 2) - 14;
  const circ = Math.PI * r;
  const dash = pct * circ;
  const cx   = size / 2, cy = size / 2;
  return (
    <svg width={size} height={size / 2 + 28} viewBox={`0 0 ${size} ${size / 2 + 28}`} style={{ overflow: "visible" }}>
      <path d={`M 14 ${cy} A ${r} ${r} 0 0 1 ${size - 14} ${cy}`} fill="none" stroke="#1E3A5F" strokeWidth="12" strokeLinecap="round" />
      <motion.path d={`M 14 ${cy} A ${r} ${r} 0 0 1 ${size - 14} ${cy}`} fill="none" stroke={color} strokeWidth="12" strokeLinecap="round"
        initial={{ strokeDasharray: `0 ${circ}` }} animate={{ strokeDasharray: `${dash} ${circ}` }}
        transition={{ duration: 1.2, ease: "easeOut" }} />
      <text x={cx} y={cy - 2} textAnchor="middle" fill={color} fontSize="28" fontWeight="bold" fontFamily="sans-serif">{score.toFixed(1)}</text>
      <text x={cx} y={cy + 16} textAnchor="middle" fill={B.subText} fontSize="11" fontFamily="sans-serif">OUT OF {max}.0</text>
    </svg>
  );
}